import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import './InvestLink.scss';

interface Props {
   className?: string;
}

const InvestLink: FC<Props> = ({ className }) => {
   const [t] = useTranslation();

   return (
      <a
         className={`invest-link${className ? ` ${className}` : ''}`}
         href="https://bronui-invest.com"
         target="_blank"
         rel="noopener noreferrer"
      >
         <i className={'invest-link__icon'}>
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
               <g opacity="0.5">
                  <path
                     d="M16 14C16 14.5523 15.5523 15 15 15C14.4477 15 14 14.5523 14 14C14 13.4477 14.4477 13 15 13C15.5523 13 16 13.4477 16 14ZM15 18C15.5523 18 16 17.5523 16 17C16 16.4477 15.5523 16 15 16C14.4477 16 14 16.4477 14 17C14 17.5523 14.4477 18 15 18ZM16 20C16 20.5523 15.5523 21 15 21C14.4477 21 14 20.5523 14 20C14 19.4477 14.4477 19 15 19C15.5523 19 16 19.4477 16 20ZM16 23C16 23.5523 15.5523 24 15 24C14.4477 24 14 23.5523 14 23C14 22.4477 14.4477 22 15 22C15.5523 22 16 22.4477 16 23ZM15 27C15.5523 27 16 26.5523 16 26C16 25.4477 15.5523 25 15 25C14.4477 25 14 25.4477 14 26C14 26.5523 14.4477 27 15 27ZM22 24C22.5523 24 23 23.5523 23 23C23 22.4477 22.5523 22 22 22C21.4477 22 21 22.4477 21 23C21 23.5523 21.4477 24 22 24ZM25 24C25.5523 24 26 23.5523 26 23C26 22.4477 25.5523 22 25 22C24.4477 22 24 22.4477 24 23C24 23.5523 24.4477 24 25 24ZM25 21C25.5523 21 26 20.5523 26 20C26 19.4477 25.5523 19 25 19C24.4477 19 24 19.4477 24 20C24 20.5523 24.4477 21 25 21ZM23 20C23 20.5523 22.5523 21 22 21C21.4477 21 21 20.5523 21 20C21 19.4477 21.4477 19 22 19C22.5523 19 23 19.4477 23 20ZM25 18C25.5523 18 26 17.5523 26 17C26 16.4477 25.5523 16 25 16C24.4477 16 24 16.4477 24 17C24 17.5523 24.4477 18 25 18ZM23 17C23 17.5523 22.5523 18 22 18C21.4477 18 21 17.5523 21 17C21 16.4477 21.4477 16 22 16C22.5523 16 23 16.4477 23 17ZM22 13V12.25C22 11.0074 20.9926 10 19.75 10H13.25C12.0074 10 11 11.0074 11 12.25V28.75C11 29.1642 11.3358 29.5 11.75 29.5H28.25C28.6642 29.5 29 29.1642 29 28.75V15.25C29 14.0074 27.9926 13 26.75 13H22ZM12.5 12.25C12.5 11.8358 12.8358 11.5 13.25 11.5H19.75C20.1642 11.5 20.5 11.8358 20.5 12.25V13H20.25C19.0074 13 18 14.0074 18 15.25V28H12.5V12.25ZM22.5 28V26.5H24.5V28H22.5ZM26 25.75C26 25.3358 25.6642 25 25.25 25H21.75C21.3358 25 21 25.3358 21 25.75V28H19.5V15.25C19.5 14.8358 19.8358 14.5 20.25 14.5H26.75C27.1642 14.5 27.5 14.8358 27.5 15.25V28H26V25.75Z"
                     fill="currentColor"
                  />
               </g>
            </svg>
         </i>
         <span className={'invest-link__texts'}>
            <span className={'invest-link__title'}>Bronui Invest</span>
            <span className={'invest-link__subtitle'}>{t('Інвестиції в готелі')}</span>
         </span>
         <span className="invest-link__badge">New</span>
      </a>
   );
};

export default InvestLink;
